export default "__VITE_ASSET__D9BNTo96__"